import React, {Component} from "react";
import KeyboardInput from "../../InputKeyboard";
import PropTypes from "prop-types";

class CustomComponent extends Component {
    render () {
        let { input, type, placeholder } = this.props;
        return <KeyboardInput type={type} placeholder={placeholder} onChange={input.onChange}/>;
    }
}

CustomComponent.propTypes = {
    type: PropTypes.string,
    placeholder: PropTypes.string,
    input: PropTypes.object
};

export default CustomComponent;